import React from 'react';
import styled from 'styled-components';
import {Line} from '@styled-icons/fa-brands/Line';
import {ShoppingCart} from '@styled-icons/material/ShoppingCart';
import {FacebookFilled, YoutubeFilled} from '@ant-design/icons';
import {useOutlet} from 'reconnect.js';
import * as NavUtil from '../../Utils/NavUtil';

function FixedLinkButtons(props) {
  const footerConfig = NavUtil.getFooterConfig(props);
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  return (
    <Wrapper mobile={mobile}>
      <button className="link-btn">
        <a href="https://www.ystore.com.tw" target="_blank" rel="noreferrer">
          <ShoppingCart size={24} />
        </a>
      </button>

      <button className="link-btn">
        <a href={footerConfig.social_fb} target="_blank" rel="noreferrer">
          <FacebookFilled style={{fontSize: 24, color: '#1877f2'}} />
        </a>
      </button>

      <button className="link-btn">
        <a href={footerConfig.social_line} target="_blank" rel="noreferrer">
          <Line size={24} style={{color: '#07b53b'}} />
        </a>
      </button>

      <button className="link-btn">
        <a
          href="https://www.youtube.com/user/ystore21"
          target="_blank"
          rel="noreferrer">
          <YoutubeFilled style={{fontSize: 24, color: '#ff0000'}} />
        </a>
      </button>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 5px;
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 101;

  display: flex;
  flex-direction: column;

  & button {
    margin-bottom: 8px;
    border: 0px;
    background-color: #ffffff;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);

    display: flex;
    justify-content: center;
    align-items: center;

    :hover {
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);
    }
  }
`;

export default FixedLinkButtons;
